<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            排出事業者詳細
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      加入者番号
                    </div>
                    <h4>{{ emission.subscriber_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      EDI利用確認キー
                    </div>
                    <h4>{{ emission.edi_usage_key }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="overline">
                      加入者名
                    </div>
                    <h4>{{ emission.name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      JWNET料金プラン
                    </div>
                    <h4>{{ emission.jwnet_price_plan | jwnet_price_plan }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      C料金団体代表者の加入者番号
                    </div>
                    <h4>{{ emission.parent_subscriber_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      C料金団体代表者の加入者名
                    </div>
                    <h4>{{ emission.parent_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      登録料請求先
                    </div>
                    <h4>{{ emission.registration_fee_type | registration_fee_type }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row v-if="false">
                  <v-col cols="12" md="3">
                    <div class="overline">
                      申請者の加入者番号
                    </div>
                    <h4>{{ emission.applicant_subscriber_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      申請者の加入者名称
                    </div>
                    <h4>{{ emission.applicant_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      作成日時
                    </div>
                    <h4>{{ emission.created_at | unix_datetime_format }}</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      更新日時
                    </div>
                    <h4>{{ emission.updated_at | unix_datetime_format }}</h4>
                    <v-divider />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-title>
            申請者情報
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="tableHeaders"
                  :items="emission.dxe_emission_requesters"
                  :items-per-page="-1"
                  hide-default-footer
                  disable-pagination
                  disable-sort
                >
                  <template v-slot:[`item.emission_count`]="{ item }">
                      {{ item.emission_count }}件
                  </template>
                  <template v-slot:[`item.sent_at`]="{item}">
                    {{ item.sent_at | unix_datetime_format }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn
              color="error"
              @click="deleteButtonClickEvent"
            >
              削除
            </v-btn>
            <v-spacer />
            <v-btn
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import Confirm from "../../../../components/Confirm";
import { mapActions} from 'vuex'

export default {
  name: 'AdminMasterEmission',
  components: {
    Confirm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '排出事業者一覧', disabled: false, to: '/admin/masters/emissions', exact: true },
        { text: '排出事業者詳細', disabled: true, to: '' },
      ],
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'tenant_name', text: '加入者名' },
        { value: 'emission_count', text: 'EDI利用数' },
        { value: 'sent_at', text: 'お知らせ作成日時' },
      ],
      emission: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    this.fetchEmission({ id: this.$route.params.id }).then((content) => {
      this.emission = content
    })
  },
  methods: {
    ...mapActions('AdminMasterEmission', {
      fetchEmission: 'show',
      deleteEmission: 'destroy',
    }),
    editButtonClickEvent () {
      this.$router.push({name: 'AdminMasterEmissionEdit', params: { id: String(this.emission.id) }})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteEmission({id: this.emission.id }).then(() =>{
            this.$router.push({name: 'AdminMasterEmissions'})
          })
        }
      })
    },
    cancelButtonClickEvent () {
      this.$router.push({name: 'AdminMasterEmissions'})
    },
  }
}
</script>

<style scoped>

</style>
